// extracted by mini-css-extract-plugin
module.exports = {"paginator":"Paginator_paginator__35RE8","summary":"Paginator_summary__1_xcG","nav":"Paginator_nav__1Ut4l","disabled":"Paginator_disabled__NBbcv"};